export default "__VITE_ASSET__C96AWPAM__"